import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import Firebase from 'firebase';



class step4 extends Component {
    constructor() {
        super();
        this.state = {
            send: false,
            actived: false
        }
    }

    componentWillUpdate(nextProps, nextState) {
        const contex = this;
        if (nextState.actived) {
            contex.props.history.push("/login")
        }
    }

    componentWillMount() {
        const contex = this;
        this.setState({ email: Firebase.auth().currentUser.email })
        Firebase.auth().onAuthStateChanged(function (user) {
            contex.setState({ actived: user.emailVerified })
        });
    }

    validation() {
        const contex = this;
        var user = Firebase.auth().currentUser;
        var userRef = Firebase.database().ref("admin_users/" + user.uid);
        var cod = parseInt(this.state.codigo)
        userRef.child("codigo").on("value", snap => {
            if (snap.val() === cod) {
                userRef.child("verified").set(true).then(resp => {
                    contex.setState({ actived: true })
                })
            } else {
                console.log("no valido")
            }
        })
    }

    reSend(){
        var user = Firebase.auth().currentUser;
        var userRef = Firebase.database().ref("admin_users/" + user.uid);
        userRef.child("modified_at").set(Firebase.database.ServerValue.TIMESTAMP).then(resp=>{
            this.setState({send : true})
        })
    }

    render() {
        return (
            <fieldset >
                <h3>Tu cuenta ha sido creada!!</h3>
                <p className="text-muted">Se ha enviado un correo de verificación a <a href="#">{this.state.email}</a> con un código para activar tu cuenta.</p>
                <p style={{ textAlign: "center", color: "#4183c4", cursor: "pointer" }}>
                    <a onClick={() => { this.reSend() }} style={this.state.send ? { display: "none" } : {}} >Enviar nuevamente</a>
                </p>
                <br />
                <br />
                <div className="text-center">
                    <input type="text" className="input2" value={this.state.codigo} onChange={(e) => { this.setState({ codigo: e.target.value }) }} placeholder="Ingrese código de verificación" />
                    <br />
                    <button type="button" className="btn btn-outline-primary" onClick={() => this.validation()}>Validar</button>
                </div>
            </fieldset >
        );
    }
}
export default step4;


// WEBPACK FOOTER //
// ./src/views/register/step4.js